<script lang="ts">
	import type { Device } from 'src/types/Device';
	import ZonesList from './ZonesList.svelte';
	import ZonesCanvas from '../../CameraPlayer/ZonesCanvas.svelte';
	import VideoContainer from '../../CameraPlayer/VideoContainer.svelte';
	import WebRTCPlayer from '../../CameraPlayer/WebRTCPlayer.svelte';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
	import { getCameraZones } from '../../helpers/camera-zone-helpers';

	export let device: Device;

	const realId = real_id(device.id);

	$: settingsStore = getDeviceSettings(realId);
	$: device_settings = $settingsStore;
	$: cameraZones = getCameraZones(device_settings).filter((zone) => zone.enable);

	// Stream to share with AddEditZoneModal (avoids duplicate WebRTC connections)
	let currentStream: MediaStream = null;
</script>

<div class="mb-s">
	<ZonesCanvas zones={cameraZones}>
		<VideoContainer isZoomable={false}>
			<WebRTCPlayer deviceId={device.id} showControls={false} bind:currentStream />
		</VideoContainer>
	</ZonesCanvas>
</div>

<ZonesList {device} existingMediaStream={currentStream} />
